window.findContentMidpoint = function (elem) {
	var contentHeight = $(elem).height();
	var midPoint = $(elem).offset().top + (contentHeight / 2);
	//console.log('area:');
	//console.log(elem);
	//console.log('midPoint: ' + midPoint);
	var lastElem = null;

	$(elem).find('*').each(function () {
		//console.log(this);
		//console.log($(this).offset().top);
		if ($(this).offset().top >= midPoint) {
			return false;
		} else {
			lastElem = this;
		}
	});
	//console.log('final');
	//console.log(lastElem);
	//console.log($(lastElem).closest('p,div,ul,h1,h2,h3,h4,h5,h6,table').get(0));
	if ($(lastElem).closest('table').length > 0) {
		return $(lastElem).closest('table').get(0);
	} else {
		return $(lastElem).closest('p,div,ul,h1,h2,h3,h4,h5,h6').get(0);
	}
};

document.addEventListener('DOMContentLoaded', function (ev) {
	if ($('.adzone-middle').length > 0) {
		var midPoint = null;
		if ($('.page-copy-area').length > 0) {
			midPoint = findContentMidpoint($('.page-copy-area'));
		} else {
			midPoint = findContentMidpoint($('main.site-main'));
		}
		$('.adzone-middle').insertAfter(midPoint);
	}

	$('.adzone-responsive').each(function (i) {
		if (window.innerWidth > 800) {
			$(this).attr('data-revive-zoneid', $(this).attr('data-zoneid-desktop'));
		} else {
			$(this).attr('data-revive-zoneid', $(this).attr('data-zoneid-mobile'));
		}
	});

	$('.adzone').each(function (i) {
		var adzone = this;
		if (typeof aptaData === 'object') {
			$.each(aptaData, function (key) {
				$(adzone).attr('data-revive-' + key, escape(this));
			});
		}
	});

	if ($('.adzone-fullwidth').length > 0) {
		var pollAds = setInterval(function () {
			if ($('.adzone-fullwidth iframe').length > 0) {
				$('.adzone-fullwidth iframe').css('width', '100%');
				clearInterval(pollAds);
			}
		}, 1000);
	}



	var url = "//servedby.revive-adserver.net/asyncjs.php?1=1";

	if (typeof aptaData === 'object') {
		$.each(aptaData, function (key) {
			url = url + "&" + key + "=" + this;
		});
	}
	$.getScript(url, function () { });


});
